import {
  FaYoutube,
  FaFacebook,
  FaBandcamp,
  FaSpotify,
  FaInstagram,
  FaItunes,
} from 'react-icons/fa'

const socialData = [
  {
    icon: <FaFacebook />,
    link: 'https://www.facebook.com/ashevillemountainboys',
    id: '1',
  },
  {
    icon: <FaYoutube />,
    link: 'https://www.youtube.com/@AshevilleMountainBoys',
    id: '2',
  },
  {
    icon: <FaInstagram />,
    link: 'https://www.instagram.com/ashevillemountainboys/',
    id: '3',
  },
  {
    icon: <FaSpotify />,
    link: 'https://open.spotify.com/album/5xDbHCBG7CHZtzwU54FXnm?si=-ra53jrGRue423TR3eP7bQ',
    id: '4',
  },
  {
    icon: <FaBandcamp />,
    link: 'https://ashevillemountainboys.bandcamp.com/merch',
    id: '5',
  },
  {
    icon: <FaItunes />,
    link: 'https://music.apple.com/us/album/the-asheville-mountain-boys/1867072559',
    id: '6',
  },
]

export default socialData
